export const __CategoriesLang = {
    noData: 'دسته بندی ای برای خدمت ها وجود ندارد.',
    back: 'بازگشت به خانه',
};
